import { useEffect, useState } from "react";
import HeaderStep from "../../../Pages/AddOrEditPartner/PartnerSteps/HeaderStep";
import CoursesInPackage from "./CoursesInPackage";
import { getCoursesForAddNewPackage } from "../../../apis";

const PackageStepThree = ({
  errors,
  touched,
  handleBlur,
  setFieldValue,
  handleChange,
  values,
  numOfCourses = 1,
  coursesData,
}) => {
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    setFieldValue("courses", coursesData);
  }, [coursesData, setFieldValue]);

  useEffect(() => {
    getCoursesForAddNewPackage()
      .then((response) => {
        setCourses(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <div className="card !tw-rounded-xl">
      <div className="tw-rounded-t-xl tw-overflow-hidden">
        <HeaderStep stepNumber={3} stepName={"Courses Data"} stepText="Part" />
      </div>
      <div className="card-body tw-shadow-xl tw-rounded-xl">
        {Array.from({ length: numOfCourses }, (i) => i + 1)?.map((_, index) => (
          <div className="row" key={index}>
            <CoursesInPackage
              values={values}
              courses={courses || []}
              errors={errors}
              handleBlur={handleBlur}
              handleChange={handleChange}
              setFieldValue={setFieldValue}
              touched={touched}
              index={index}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PackageStepThree;
